import { render, staticRenderFns } from "./HasMessagesAlert.vue?vue&type=template&id=774b2df0&scoped=true&"
import script from "./HasMessagesAlert.vue?vue&type=script&lang=ts&"
export * from "./HasMessagesAlert.vue?vue&type=script&lang=ts&"
import style0 from "./HasMessagesAlert.vue?vue&type=style&index=0&id=774b2df0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774b2df0",
  null
  
)

export default component.exports